export default "__VITE_ASSET__ad_6grUS__"